import VueChartJS from 'vue-chartjs'
import ChartJSDatalabels from 'chartjs-plugin-datalabels'
//import { Config } from '@/utility'

export default{
    extends:VueChartJS.Pie,
    mixins:VueChartJS.mixins.reactiveProp,
    props:["data","page","disable","url","legendposition"],
    methods:{
		redraw() {
        var options={
            responsive:true,
            maintainAspectRasio:true,
            cutoutPercentage: 50,
            onClick:()=>{
                if (this.url) window.open(this.url,'_blank')
            },
            legend:{
              display: true,
              position: 'top', //this.legendposition ? this.legendposition: 'top', // Place legend on the left side
            },
            tooltips:{
                mode:'label', //index,
                callbacks: {
                    /*
                    label: function(tooltipItem, data) {
                        var label = data.labels[tooltipItem.index];
                        var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString();
                        return label+": "+value + "%";
                    }, */
                    label: function (tooltipItem, data) {
                        try {
                          let valueReal = parseFloat(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]).toLocaleString('en-US');
                          let label = ' ' + data.labels[tooltipItem.index] || '';

                          if (label) {
                            label += ': ';
                          }

                          if(valueReal) {
                            label += valueReal + ' ';
                          }

                          const sum = data.datasets[0].data.reduce((accumulator, curValue) => {
                            return parseFloat(accumulator) + parseFloat(curValue); //accumulator + curValue;
                          });
                          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                          //console.log("sum: "+ sum);
                          label += "("+Number((value / sum) * 100).toFixed(2) + '%)';
                          return label;
                        } catch (error) {
                          console.log(error);
                        }
                    }
                },
            },
            /*
            layout: {
              padding: 0,
            },
            plugins: {
              textMargin: 0,
              datalabels: {
                color: '#000000',
                anchor: 'end',
                align: 'center',
                labels: {
                  title: {
                    font: {
                      weight: 'normal'
                    }
                  },
                  value: {
                    color: '#333'
                  }
                },
                padding: {
                  top: 0,
                  bottom:0,
                },
              }
            }
            */
            /*
            plugins: {
                datalabels: {
                  formatter: (value, ctx) => {

                    let datasets = ctx.chart.data.datasets;

                    if (datasets.indexOf(ctx.dataset) === datasets.length - 1) {
                      let sum = datasets[0].data.reduce((a, b) => a + b, 0);
                      let percentage = Math.round((value / sum) * 100) + '%';
                      return percentage;
                    } else {
                      return percentage;
                    }
                  },
                  color: '#fff',
                }
              }, */
        }
        //var position=Math.round(this.data.labels.indexOf(this.disable));
        var position = Math.round(this.data.labels?.indexOf(this.disable) ?? -1);
        if(position >=0 )
        {
            // console.log("this.disable: ",position+" : "+this.disable)
            // this.data.datasets[0].backgroundColor[position]="#CCCCCC"

        }
        //this.addPlugin(ChartJSDatalabels)
        this.renderChart(this.data,options)
		}
    },
	mounted(){
		this.redraw();
	},
	watch: {
		data: function() {
			this.redraw();
		}
	}
}
